var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.color,"small":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }